<template>
  <div class="album_auth_pop" @touchmove.prevent>
    <div class="pop_container">
      <div class="pop_title">温馨提示</div>
      <div class="pop_content">
        确认要删除“{{ keyItem?.description }}”的 API Key吗？删除后该API
        Key无法继续使用。
      </div>
      <div class="pop_bottom">
        <div class="cancel_btn" @click="clickCancelBtn">取消</div>
        <div class="confirm_btn" @click="clickConfirmBtn">确认</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  keyItem: {
    type: Object,
  },
});
const emit = defineEmits(["handleConfirmPop"]);

const clickConfirmBtn = () => {
  emit("handleConfirmPop", true, props.keyItem?.apiKey);
};
const clickCancelBtn = () => {
  emit("handleConfirmPop", false);
};
</script>

<style lang="scss" scoped>
.album_auth_pop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #0000009a;
  z-index: 20;

  .pop_container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 6rem;
    height: 3.72rem;
    background-color: #ffffff;
    border-radius: 0.42rem;
    overflow: hidden;

    .pop_title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      height: 0.88rem;
      color: #000000;
      font-size: 0.34rem;
    }

    .pop_content {
      box-sizing: border-box;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 0 0.42rem;
      color: #666;
      font-size: 0.26rem;
    }
    .pop_bottom {
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 1.02rem;
      border-top: #fafafa 0.02rem solid;

      .cancel_btn {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #666;
        font-size: 0.32rem;
        border-right: #fafafa 0.02rem solid;
      }

      .confirm_btn {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #ff5500;
        font-size: 0.32rem;
      }
    }
  }
}
</style>
